import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getEnriched2010Url, getTransactionType, readEnvFile, retrieveURLUponSelection, } from '../utils';
const { CAF2010Url } = readEnvFile();
export const getDefaultPropertyType = () => {
    try {
        const urlParams = new URLSearchParams(window.location.search);
        const estateType = urlParams.get('esr') ?? '';
        return getTransactionType(estateType) ?? 'BUY';
    }
    catch (error) {
        console.error(error);
    }
    return 'BUY';
};
export const useDispatcher = (searchParams) => {
    const { t } = useTranslation();
    const [propertyType, setPropertyType] = useState('');
    const [isRedirectionLoading, setIsRedirectionLoading] = useState(false);
    const [transactionType, setTransactionType] = useState(getDefaultPropertyType());
    const [error, setError] = useState('');
    const handlePropertyTypeChange = (value) => {
        setPropertyType(value);
        if (error) {
            setError('');
        }
    };
    const handleTransactionTypeChange = (value) => {
        setTransactionType(value);
    };
    const handleConfirmation = async () => {
        if (!propertyType) {
            setError(t('error'));
            return;
        }
        setIsRedirectionLoading(true);
        const url = await retrieveURLUponSelection(propertyType, transactionType);
        window.location.href =
            url === CAF2010Url
                ? getEnriched2010Url({
                    searchParams,
                    transactionType,
                    propertyType: propertyType,
                })
                : `${url}?propertyType=${propertyType}&transactionType=${transactionType}`;
    };
    return {
        propertyType,
        transactionType,
        handlePropertyTypeChange,
        handleTransactionTypeChange,
        handleConfirmation,
        error,
        t,
        isRedirectionLoading,
    };
};
